@import '@speechki-frontend/shared/assets/scss/_vars';

.audio-editor {
    position: relative;

    &__toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 15px;
        border-bottom: 1px solid $gray;
    }

    &__player {
        flex: 1;

        .player {
            margin-left: 15px;
        }
    }

    &__waves-wrapper {
        position: relative;
        overflow-x: auto;
        overflow-y: hidden;
        min-height: 150px;
        padding: 0 0 20px;
        display: flex;
        align-items: flex-end;
    }

    &__waves-container {
        position: relative;
    }

    &__filler {
        position: absolute;
        top: 10px;
        border-left: solid 2px var(--primaryColor);
        border-right: solid 2px var(--primaryColor);
        background-color: rgba($primary, 0.5);

        >span {
            position: absolute;
            top: 0;
            right: 0;
            transform: translate(50%, -100%);
            font-size: 9px;
            color: $primary;
        }

        &--rtl {
            transform: scale(-1) translateX(100%);

            > span {
                transform: translate(50%, -100%) scale(-1);
            }
        }
    }

    &__segments {
        position: absolute;
        top: 10px;
        left: 0;
    }

    &__inner-controls {
        display: flex;
        align-items: center;
        width: 100%;
        z-index: 9999;
        margin-bottom: 10px;

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 18px;
            width: 18px;
            border-radius: 50%;
            min-width: 0;
            margin-right: 5px;
            padding: 0;
            font-size: 0;

            &:hover {
                background-color: var(--primaryColor);
            }

            &.is-disabled {
                opacity: .2;
            }
        }
    }

    &__zoom {
        display: flex;
    }

    &__progress {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        position: absolute;
        height: 100%;
        left: 0;
        top: 10px;
        z-index: 1000;

        &::before {
            content: '';
            width: 2px;
            flex-grow: 1;
            background-color: $heading;
        }

        &::after {
            position: static;
            content: attr(data-time);
            font-size: 9px;
            line-height: 12px;
            background-color: #fff;
        }

        &[data-time='0s'] {
            &::after {
                display: none;
            }
        }
    }

    &__tips {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 15px 0 0;
        min-height: 80px;

        >p {
            text-align: center;
            font-size: 15px;
            line-height: 20px;
            color: $darkblue;
            margin: 0;
        }
    }

    &__actions {
        display: flex;
        align-items: center;
        justify-content: center;

        .button {
            width: 110px;
            font-size: 15px;
            line-height: 20px;
            padding-left: 20px;
            padding-right: 20px;
            margin: 0 5px;

            &.button--nowrap {
                width: auto;
            }
        }
    }

    &__cut {
        width: 110px;
        height: 54px;
        padding: 6px;
        margin-left: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border: solid 1px var(--primaryColor);
        border-radius: 5px;
        line-height: 20px;

        >label {
            font-size: 15px;
            line-height: 20px;
            color: var(--primaryColor);
            display: flex;
        }

        .number-input {
            padding: 0;
            &__button {
                border: none;

                path {
                    fill: var(--primaryColor);
                }

                line {
                    stroke: var(--primaryColor);
                }
            }
        }
    }

    &__bottom {
        margin: 15px 0 0;
    }

    &__modal {
        min-height: 445px;

        .modal__head {
            padding-top: 10px;
        }

        .modal__title {
            text-align: center;
        }
    }
}